import { render, staticRenderFns } from "./ChartJSComponent.vue?vue&type=template&id=581fa514&"
import script from "./ChartJSComponent.vue?vue&type=script&lang=js&"
export * from "./ChartJSComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports